/**
 * This file creates the Provider component required by Redux.
 * 
 * First, it creates the initial state, the Redux store, and the browser history.
 * It sets the locale to English (enUS) and connects the created freshly browser history.
 * Then, we use a Route component from react-router-dom in order to 
 * render our App component.
 * 
 * In this file there is also code that allows hot reloading without ejecting create-react-app
 */

//import "babel-polyfill";
import React, { useEffect } from 'react';
// import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import { Route, useLocation } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
//import ConnectedRouter from 'react-router-redux'
//import { ConnectedRouter } from 'react-router-redux';
import configureStore from "./store/configureStore";
//import createHistory from 'history/createBrowserHistory'
import { createBrowserHistory } from 'history';
//import connectToAlerts from "./utilities/socketUtils";
//import registerServiceWorker from './registerServiceWorker';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

import ApiClient from './middleware/api'
import App from './containers/App';
import HotSwappingIntlProvider from './components/HotSwappingIntlProvider';
import seasonsActions from './actions/seasons';
import * as authActions from './actions/auth';
//import Immutable, { Map, List } from 'immutable';
//import { initializeSockets } from './middleware/sockets';
//import { GlobalConfigContext } from './components/Config/GlobalConfigContext';

const rootEl = document.getElementById('root');
const root = createRoot(rootEl);
// Let the reducers handle initial statehh
const initialState = {}
const store = configureStore(initialState);
ApiClient.store = store;
//ApiClient.context = GlobalConfigContext;
const history = createBrowserHistory({basename: ''});

const ScrollToTop = () => {
    const { pathname } = useLocation();
  
    useEffect(() => {
        // console.log(`useEffect:`)
        //   window.scrollTo(0, 0);
        document.getElementById('root').scrollIntoView({behavior: 'smooth'}, 500);
    }, [pathname]);
  
    return null;
}

//initializeSockets(store);
// Create an enhanced history that syncs navigation events with the store
//const history = syncHistoryWithStore(browserHistory, store)

//const appLocale = window.appLocale;
//addLocaleData(appLocale.data);

//store.dispatch({ type: 'LOGOUT'});
//isAuthenticated
//store.getState();
// PRELOAD DATA IF AUTHENTICATED 
const currentState = store.getState();
if(currentState && currentState.auth && currentState.auth.isAuthenticated){
    store.dispatch(seasonsActions.fetch('init_property', {}));
}
//console.log(`store.getState():`, store.getState().auth.isAuthenticated);
window.addEventListener('storage', e => {
    //console.log(`storage:`, e);
    if(e.key === 'authToken' && e.oldValue && !e.newValue) {
       store.dispatch(authActions.logout());
    }else if(e.key === 'authToken' && !e.oldValue && e.newValue){
        window.location.reload();
    }
});

// ReactDOM.render((
// 	<Provider store={store}>
// 		<HotSwappingIntlProvider>
// 			<ConnectedRouter history={history}>
//             <React.StrictMode>
//                 <ScrollToTop />
// 				<Route component={App} />
//                 </React.StrictMode>
// 			</ConnectedRouter>
// 		</HotSwappingIntlProvider>
// 	</Provider>
// ), rootEl);
root.render((
	<Provider store={store}>
		<HotSwappingIntlProvider>
			<ConnectedRouter history={history}>
            {/* <React.StrictMode> */}
                <ScrollToTop />
				<Route component={App} />
            {/* </React.StrictMode> */}
			</ConnectedRouter>
		</HotSwappingIntlProvider>
	</Provider>
));



// enable hot reloading
// if (module.hot) {
//   module.hot.accept('./containers/App', () => {
//     ReactDOM.render(
//       <Provider store={store}>
//     	<HotSwappingIntlProvider>
// 			<ConnectedRouter history={history}>
// 				<Route component={App} />
// 			</ConnectedRouter>
// 		</HotSwappingIntlProvider>
// 	</Provider>,
//       rootEl
//     );
//   }); 
// }

//registerServiceWorker();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();